import _ from 'lodash';
import uuid from 'uuid';
import produce from 'immer';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SearchState } from '../index';

const DEFAULT_RECENT_SEARCH_LOCAL_STORAGE_KEY = '__DEFAULT_RECENT_SEARCH_LS_KEY__';

export type CreateRecentSearchesPluginStoreParams = {
  localStorageKey?: string;
};

type RecentSearchesPluginStore = {
  recentSearches: ({ id: string } & SearchState)[];
  onSaveRecentSearch: (recentSearches: SearchState) => void;
};

export const createRecentSearchesPluginStore = ({
  localStorageKey = DEFAULT_RECENT_SEARCH_LOCAL_STORAGE_KEY,
}: CreateRecentSearchesPluginStoreParams) =>
  create<RecentSearchesPluginStore>()(
    persist(
      (set, get) =>
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
          recentSearches: [],
          onSaveRecentSearch: recentSearches => {
            set(
              produce(get(), draftState => {
                const index = draftState.recentSearches.findIndex(({ id, ...other }) =>
                  _.isEqual(other, recentSearches),
                );
                if (index !== -1) {
                  draftState.recentSearches.splice(index, 1);
                }
                draftState.recentSearches.unshift({
                  ...recentSearches,
                  id: uuid.v4(),
                });
                if (draftState.recentSearches.length > 10) {
                  draftState.recentSearches.pop();
                }
              }),
            );
          },
        } as RecentSearchesPluginStore),
      {
        name: localStorageKey,
        partialize: ({ recentSearches }) => ({ recentSearches }),
      },
    ),
  );
